/** Typed wrapper over fetch for /api/strategies/*. */

import { fireAndForget, getJson } from "@/lib/http";
import type {
  Strategy,
  StrategyCreateRequest,
  StrategyUpdateRequest,
  StrategyWithToken,
} from "@/types/strategy";

// Re-export so existing call sites (and tests) that imported `ApiError` from
// "@/lib/api" keep working unchanged.
export { ApiError } from "@/lib/http";

const BASE = "/api/strategies";

export const strategiesApi = {
  list(): Promise<Strategy[]> {
    return getJson<Strategy[]>(BASE);
  },
  create(payload: StrategyCreateRequest): Promise<StrategyWithToken> {
    return getJson<StrategyWithToken>(BASE, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  update(id: string, payload: StrategyUpdateRequest): Promise<Strategy> {
    return getJson<Strategy>(`${BASE}/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },
  remove(id: string): Promise<void> {
    return fireAndForget(`${BASE}/${id}`, { method: "DELETE" });
  },
  rotateToken(id: string): Promise<StrategyWithToken> {
    return getJson<StrategyWithToken>(`${BASE}/${id}/rotate-token`, {
      method: "POST",
    });
  },
};
